import { createFileRoute } from '@tanstack/react-router';
import { msg } from '@lingui/core/macro';

/**
 * Layout route for the `/park` family. Renders the default `<Outlet />`; its
 * label adds a "Parks" ancestor breadcrumb on every park page. Non-linkable:
 * there is no parks list page (parks are reached from the sidebar), so `/park`
 * itself resolves to nothing.
 */
export const Route = createFileRoute('/_logged/park')({
  staticData: { label: msg`Parks`, labelLinkable: false },
});
